[
  {
    "Provinces": "Koshi",
    "Name": "Koshi",
    "Nepali": "कोशी",
    "Capital": "Biratnagar",
    "Area_km2":  "25,905",
    "Population_2011": "4,534,943"
  },
  {
    "Provinces": "Madhesh",
    "Name": "Madhesh",
    "Nepali": "मधेश्",
    "Capital": "Janakpur",
    "Area_km2":  "9,661",
    "Population_2011": "5,404,145"
  },
  {
    "Provinces": "Bagmati",
    "Name": "Bagmati",
    "Nepali": "बागमती",
    "Capital": "Hetauda",
    "Area_km2":  "20,300",
    "Population_2011": "5,529,452"
  },
  {
    "Provinces": "Gandaki",
    "Name": "Gandaki",
    "Nepali": "गण्डकी",
    "Capital": "Pokhara",
    "Area_km2":  "21,504",
    "Population_2011": "2,413,907"
  },
  {
    "Provinces": "Lumbini",
    "Name": "Lumbini",
    "Nepali": "लुम्बिनि",
    "Capital": "Butwal",
    "Area_km2":  "22,288",
    "Population_2011": "4,891,025"
  },
  {
    "Provinces": "Karnali",
    "Name": "Karnali",
    "Nepali": "कर्णाली",
    "Capital": "Birendranagar",
    "Area_km2":  "27,984",
    "Population_2011": "1,168,515"
  },
  {
    "Provinces": "SudurPaschim",
    "Name": "SudurPaschim ",
    "Nepali": "सुदुर्पश्चिम",
    "Capital": "Godawari",
    "Area_km2":  "19,539",
    "Population_2011": "2,552,517"
  }
]
